/* eslint-disable no-unused-expressions */
import track from './track';

const headerCtaClickEvent = {
  eventName: 'cta_clicked',
  payload: {
    ctaType: 'primary',
    label: 'Sign Up',
    pageLocation: 'minimalist header',
  },
};

const trackHeaderClick = ({ eventName, payload }) => {
  track(eventName, payload);
};

// Wires the minimalist-header sign-up CTA. No-ops on pages without that button.
const initLandingPageTracking = () => {
  const headerCta = document.getElementById('minimalist-header-cta-button');
  headerCta &&
    headerCta.addEventListener('click', () =>
      trackHeaderClick(headerCtaClickEvent),
    );
};

document.addEventListener('DOMContentLoaded', initLandingPageTracking);

export { initLandingPageTracking, headerCtaClickEvent };
